export default "__VITE_PUBLIC_ASSET__30ad0680__"